import axios from 'axios';

const host = window.location.hostname;
const protocol = window.location.protocol;
let API_HOST = `${protocol}//${host}`;
if (host.includes('localhost')) {
    API_HOST = `${API_HOST}:8001`;
}

const API = `${API_HOST}/api`;

// Create axios instance for direct use
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const api = {
  // Direct axios methods
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  patch: (url, data, config) => apiClient.patch(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
  
  // Projects
  getProjects: async (status = null) => {
    const params = status ? { status } : {};
    const response = await apiClient.get('/projects', { params });
    return response.data;
  },
  
  getProject: async (id) => {
    const response = await apiClient.get(`/projects/${id}`);
    return response.data;
  },
  
  createProject: async (data) => {
    const response = await apiClient.post('/projects', data);
    return response.data;
  },
  
  updateProject: async (id, data) => {
    const response = await apiClient.patch(`/projects/${id}`, data);
    return response.data;
  },
  
  deleteProject: async (id) => {
    const response = await apiClient.delete(`/projects/${id}`);
    return response.data;
  },
  
  duplicateProject: async (id, newName) => {
    const response = await apiClient.post(`/projects/${id}/duplicate?new_name=${encodeURIComponent(newName)}`);
    return response.data;
  },
  
  // Templates
  getTemplates: async () => {
    const response = await apiClient.get('/templates');
    return response.data;
  },
  
  getTemplateByType: async (projectType) => {
    const response = await apiClient.get(`/templates/${projectType}`);
    return response.data;
  },
  
  // Consultants
  getConsultants: async (role = null) => {
    const params = role ? { role } : {};
    const response = await apiClient.get('/consultants', { params });
    return response.data;
  },
  
  createConsultant: async (data) => {
    const response = await apiClient.post('/consultants', data);
    return response.data;
  },
  
  // Share & Collaboration
  generateShareCode: async (projectId) => {
    const response = await apiClient.post(`/projects/${projectId}/generate-share-code`);
    return response.data;
  },
  
  getProjectByShareCode: async (shareCode) => {
    const response = await apiClient.get(`/projects/by-code/${shareCode}`);
    return response.data;
  },
  
  // Files
  uploadFile: async (projectId, fileData) => {
    const response = await apiClient.post(`/projects/${projectId}/files`, fileData);
    return response.data;
  },
  
  deleteFile: async (projectId, fileId) => {
    const response = await apiClient.delete(`/projects/${projectId}/files/${fileId}`);
    return response.data;
  },
  
  // Comments
  addComment: async (projectId, commentData) => {
    const response = await apiClient.post(`/projects/${projectId}/comments`, commentData);
    return response.data;
  },
  
  updateComment: async (projectId, commentId, data) => {
    const response = await apiClient.patch(`/projects/${projectId}/comments/${commentId}`, data);
    return response.data;
  },
  
  deleteComment: async (projectId, commentId) => {
    const response = await apiClient.delete(`/projects/${projectId}/comments/${commentId}`);
    return response.data;
  },
};

export default api;